import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { BaseInputDirective } from '../base-input.directive';
import * as moment from 'moment-timezone';
import { ErrorDefinition } from '../../models/error-definition';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../material/material.module';
import { UtilityModule } from '../../../utility/utility.module';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { EasternMomemtPipe } from '../../../utility/local-moment.pipe';
import { UTCMomentPipe } from '../../../utility/utc-moment.pipe';
import { DateFormatPipe } from '../../../utility/date-format.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatDatepickerModule, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    UtilityModule,
    MatFormField,
    MatHint,
    MatError,
    EasternMomemtPipe, UTCMomentPipe,
    DateFormatPipe,
    MatLabel,
    MatIconModule,
    MatInput,
    MatDatepickerModule,
    MatDatepickerToggle,
    MatTooltipModule,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'MM/DD/YYYY',
        },
        display: {
          dateInput: 'MM/DD/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class DateInputComponent extends BaseInputDirective implements OnInit {
  minValueDisplay: string;
  maxValueDisplay: string;
  @Input() showEstOnReadOnly: boolean = false;

  
 


  ngOnInit() {
    super.ngOnInit();

    if (this.hint == null) {
      this.hint = '(mm/dd/yyyy)';
    }

    this.adjustErrorMessages();
  }

  // dateChanged(event: any) {
  //   const dateString = event.targetElement?.value;
  //   const dateFormatRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  //   // // this.formControl.value will be null if the format is invalid. This is set by the Material datepicker
  //   if (!dateFormatRegex.test(dateString)) {
  //     this.formControl.setValue(null);
  //     // this.formControl.setErrors({ invalidDateFormat: true });
  //   }

  //   if (dateFormatRegex.test(dateString)) {
  //     const offset = new Date(event.target.value).getTimezoneOffset();
  //     const dateWithOffset = moment(event.target.value).utcOffset(offset);
  //     this.change.emit(dateWithOffset);
  //   } else {
  //     this.change.emit(null);
  //   }
  // }

  dateChanged(event: any) {
  // 1. Capture what the user physically typed right now
    const dateString = event.targetElement?.value;
    const dateFormatRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

    if (!dateFormatRegex.test(dateString)) {
    // 2. Prevent Angular Material from doing its default auto-parse on blur
      if (event.nativeEvent) {
        event.nativeEvent.preventDefault();
        event.nativeEvent.stopPropagation();
      }

    // 3. Set the form state as invalid without changing the typed string value to null
      this.formControl.setErrors({ invalidDateFormat: true });
      this.formControl.markAsTouched();
      this.formControl.markAsDirty();

    // 4. Force the native browser input element to keep the raw string exactly as-is
      if (event.targetElement) {
        setTimeout(() => {
          event.targetElement.value = dateString; // Locks "01" into the display box
        }, 0);
      }

      this.change.emit(null);
      return;
    }

  // Handle completely valid date scenarios
    if (event.target.value) {
      const offset = new Date(event.target.value).getTimezoneOffset();
      const dateWithOffset = moment(event.target.value).utcOffset(offset);
      this.change.emit(dateWithOffset);
    } else {
      this.change.emit(null);
    }
  }



  private adjustErrorMessages() {
    this.minValueDisplay = moment(this.fgInfo.minValue).format('MM/DD/YYYY');
    this.maxValueDisplay = moment(this.fgInfo.maxValue).format('MM/DD/YYYY');

    const minErrorDefinition = this.errorDefinitions.find(
      (value: ErrorDefinition) => value.key === 'min',
    );
    const maxErrorDefinition = this.errorDefinitions.find(
      (value: ErrorDefinition) => value.key === 'max',
    );

    minErrorDefinition.errorMessage = this.errorService.convertMessageToFn(
      `${this.fgInfo.label} must be after ${this.minValueDisplay}`,
    );
    maxErrorDefinition.errorMessage = this.errorService.convertMessageToFn(
      `${this.fgInfo.label} must be before ${this.maxValueDisplay}`,
    );
  }
}
